import dayjs from "dayjs";
import {EmploymentTypes} from "../../../../models";

const elements = {
    "elements": [
        {
            "name": "seciton-b",
            "type": "",
            "page": 2
        },
        {
            "name": "account-number",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "applicant-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "applicant-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "id-check",
            "type": "CHECK",
            "page": 3
        },
        {
            "name": "intermediary-name-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "intermediary-name-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "repay-check",
            "type": "CHECK",
            "page": 3
        },
        {
            "name": "repay-docs-1",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "repay-docs-2",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "sign-kev",
            "type": "SIGNKEVIN",
            "page": 3
        },
        {
            "name": "signer-name",
            "type": "TEXT",
            "page": 3
        },
        {
            "name": "todays-date",
            "type": "TEXT",
            "page": 3
        }
    ],
}
export default function (mortgage, config) {
    let app1PAYE = !!mortgage.applicant1.employmentIncome.find(it => it.employmentType === EmploymentTypes.EMPLOYED)
    let app2PAYE = mortgage.twoApplicants ?  !!mortgage.applicant2.employmentIncome.find(it => it.employmentType === EmploymentTypes.EMPLOYED) : false
    let app1SelfEmployed = !!mortgage.applicant1.employmentIncome.find(it => it.employmentType === EmploymentTypes.SELFEMPLOYED)
    let app2SelfEmployed = mortgage.twoApplicants ? !!mortgage.applicant2.employmentIncome.find(it => it.employmentType === EmploymentTypes.SELFEMPLOYED) : false


    const ask = []
    const errors = []
    const map = {}
    const fill={}
    /*
    CHcknoxes removed from most recent doc
    fill['Check Box 1'] = {check: true}
    fill['Check Box 2'] = {check: true}
    fill['Check Box 3'] = {check: true}
    fill['Check Box 4'] = {check: true}
    fill['Check Box 5'] = {check: true}
    fill['Check Box 6'] = {check: true}
    fill['Check Box 7'] = {check: true}
    fill['Check Box 8'] = {check: true}
    fill['Check Box 9-0'] = {check: true}
    if (app1PAYE || app2PAYE){
        fill['Check Box 9'] = {check: true}
        fill['Check Box 10'] = {check: true}
        fill['Check Box 11'] = {check: true}
    }
    if (app1SelfEmployed || app2SelfEmployed){
        fill['Check Box 12'] = {check: true}
        fill['Check Box 13'] = {check: true}
        fill['Check Box 14'] = {check: true}
    }
    */



    map['todays-date'] = dayjs().format('D MMMM YYYY')
    map['signer-name'] = 'Kevin Coakley'
    map['sign-kev'] = true
    map['id-check'] = true
    map['repay-check'] = true
    map['confirm-check'] = true
    map['intermediary-name-1'] = 'Truss Mortgages Ltd t/a Suss\'d Mortgages, 222 Harold\'s Cross Road, Dublin 6W'
    //map['intermediary-name-2'] = '222 Harold\'s Cross Road, Dublin 6W'
    map['applicant-1'] = mortgage.applicant1.fullName
    if (mortgage.twoApplicants){
        map['applicant-2'] = mortgage.applicant2.fullName
    }
    if (!mortgage.activeSubmission?.mortgageAccountNo){
        ask.push({
            label: 'Mortgage Account No',
            name: 'account-number',
            type: 'TEXT',
            group: 'Mortgage Details'
        })
        if (config.hasOwnProperty('account-number')) {
            map['account-number'] = config['account-number']
        }
    }
    else{
        map['account-number'] = mortgage.activeSubmission?.mortgageAccountNo
    }
    ask.push(
        {
            label: 'Section B Text',
            name: 'seciton-b',
            type: 'TEXT',
            group: 'Repayment Docs',
        },
        {
            label: 'Repay Docs Ln 1',
            name: 'repay-docs-1',
            type: 'TEXT',
            group: 'Repayment Docs'
        },
        {
            label: 'Repay Docs Ln 2',
            name: 'repay-docs-2',
            type: 'TEXT',
            group: 'Repayment Docs'
        }
    )
    if (config.hasOwnProperty('repay-docs-1')) {
        map['repay-docs-1'] = config['repay-docs-1']
    }
    if (config.hasOwnProperty('repay-docs-2')) {
        map['repay-docs-2'] = config['repay-docs-2']
    }
    if (config.hasOwnProperty('seciton-b')) {
        map['seciton-b'] = config['seciton-b']
    }
    ask.push({
        label: 'Vulnerable Customer',
        name: 'vulnerable-customer',
        type: 'CHECK',
        group: 'Other'
    })
    if (config.hasOwnProperty('vulnerable-customer')) {
        map['vunerable-yes'] = config['vulnerable-customer']
        map['vulnerable-no'] = !config['vulnerable-customer']
    }
    else{
        map['vunerable-yes'] = false
        map['vulnerable-no'] = true
    }


    return {sections:[{ask, errors, map, fill}]}



}